export const PROPERTY_TYPE_OPTIONS = [
    { value: 'any', label: 'Any' },
    { value: 'Residential', label: 'Residential' },
    { value: 'Apartment', label: 'Apartment' },
    { value: 'Cabana', label: 'Cabana' },
    { value: 'Townhouse', label: 'Townhouse' },
    { value: 'Twinhouse', label: 'Twinhouse' },
    { value: 'Villa', label: 'Villa' },
    { value: 'Commercial', label: 'Commercial' },
    { value: 'Retail', label: 'Retail' },
    { value: 'Office', label: 'Office' },
    { value: 'Medical', label: 'Medical' },
    { value: 'Clinic', label: 'Clinic' },
    { value: 'Hospitality', label: 'Hospitality' },
    { value: 'Mixed-use', label: 'Mixed-use' },
    { value: 'Resale', label: 'Resale' },
    { value: 'Rent', label: 'Rent' }
] as const;

export type PropertyTypeValue = (typeof PROPERTY_TYPE_OPTIONS)[number]['value'];
